import { Spin } from 'antd'

const AntdSpin = () => {
    return (
        <Spin className="my-spin" size="large" />
    )
}

export default AntdSpin